/* eslint-disable react/jsx-child-element-spacing */
import { AccordionDetails, AccordionSummary } from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import * as moment from 'moment';
import React from 'react';
import { withRouter } from 'react-router';

import { CommaSeparator, GetFormat, amountFormate, isOverDue } from '../../AppUtil/AppUtil';
import MobileFooter from '../Common/Profile/MobileFooter';
import PageHeaderTitle from '../Common/Profile/PageHeaderTitle';
import ExpandIcon from '../Common/Profile/SvgIcon/ExpandIcon';

import { withTranslation } from 'react-i18next';

import MobileButton from '../Common/Profile/Button';
import './style.css';
import { hot } from 'react-hot-loader';

const API_URLS = window.AppConfig.API_URLS;
const LOAN_STATES = window.AppConfig.LOAN_STATES;
const INSTALLMENT_STATE = window.AppConfig.INSTALLMENT_STATE;
const LOAN_MODIFICATION_ACTION = window.AppConfig.LOAN_MODIFICATION_ACTION;

const styles = _theme => ({
	table: {
		minWidth: 700
	}
});

const HUNDRED = 100;
const NO_OF_DAYS_IN_YEAR = 365;

const Accordion = withStyles({
	root: {
		'&$expanded': {
			margin: '2px 0'
		}
	},
	expanded: {}
})(MuiAccordion);

class AmortizationTable extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_heading: '',
			_isLoading: false,
			_lendami_service: 0
		};
	}

	startLoader = () => {
		this.setState({
			_isLoading: true
		});
	};

	stopLoader = () => {
		this.setState({
			_isLoading: false
		});
	};

	calculateInterestRate = data => {
		const emi_amount = parseFloat(data.emi_amount);
		const iRate = this.props.loanData.annual_rate / HUNDRED;
		const days = moment(data.installment_date).diff(moment(), 'days');
		const interestAmount = emi_amount * (1 + iRate / NO_OF_DAYS_IN_YEAR) ** days - emi_amount;
		const totalEmi = emi_amount + interestAmount;
		return amountFormate(totalEmi);
	};

	between = () => {};

	service_charge_fee = () => {
		const result = JSON.parse(localStorage.getItem('SERVICE_CHARGE'));

		Object.entries(this.props.table)?.length > 0 &&
			Object.entries(this.props.table).map(a =>
				result?.filter(m => {
					const total_base = Number(a[1].emi_amount);

					if (total_base >= m.min && total_base <= m.max) {
						return this.setState({ _lendami_service: m.price });
					}
				})
			);
	};

	// popUpwhenPayNow = (data) => {
	//   Swal.fire({
	//     title: "",
	//     text:
	//       this.props.t("amortization_table.text_on_pay_now_popup") +
	//       this.calculateInterestRate(data),
	//     icon: "warning",
	//     showCancelButton: true,
	//     confirmButtonColor: "#3085d6",
	//     cancelButtonColor: "#d33",
	//     cancelButtonText: this.props.t("buttons.cancel"),
	//     confirmButtonText: this.props.t("buttons.ok"),
	//   }).then((result) => {
	//     if (result.value) {
	//       this.payNow(data.id);
	//     }
	//   });
	// };

	// payNow = async (id) => {
	//   try {
	//     this.startLoader();
	//     const response = await ApiService.PatchData(
	//       `${API_URLS.INSTALLMENTS}/${id}`,
	//       {}
	//     );
	//     await this.props.refreshState();
	//     if (!response.status) {
	//       toastError(response.data);
	//     }
	//     this.stopLoader();
	//   } catch (err) {
	//     this.stopLoader();
	//     console.log(err);
	//   }
	// };

	// setheadingWhenModifiedTable = () => {
	//   let _heading = "";
	//   if (this.props.fromModifiedScreen) {
	//     if (this.props.currentUserId === this.props.loanObject.last_modified_by) {
	//       _heading =
	//         "amortization_table.message_for_modified_amortization_table_for_borrower";
	//     } else {
	//       _heading =
	//         "amortization_table.message_for_modified_amortization_table_for_lender";
	//     }
	//     this.setState({
	//       _heading,
	//     });
	//   }
	// };

	// isPayNowGeneralconditionTrue = () => {
	//   const account = this.props.currentUser.profile.account || {};
	//   let result = false;
	//   if (
	//     this.props.typeOfUser === "BORROW" &&
	//     account.funding_source_id &&
	//     (this.props.loanData.state === LOAN_STATES.APPROVE ||
	//       this.props.loanData.state === LOAN_STATES.POST_MODIFIED)
	//   ) {
	//     result = true;
	//   }
	//   return result;
	// };

	// isPayNowButtonNeedToShow = (inst) => {
	//   if (this.isPayNowGeneralconditionTrue()) {
	//     if (
	//       inst.state === INSTALLMENT_STATE.NO_BANK_FAILED ||
	//       (inst.state === INSTALLMENT_STATE.ACH_CANCEL &&
	//         this.props.loanData.frequency === "LUMP_SUM")
	//     ) {
	//       return true;
	//     }
	//   }
	//   return false;
	// };

	// isCancelPaymentButtonToShow = (inst) => {
	//   let result = false;
	//   if (
	//     this.props.typeOfUser === "BORROW" &&
	//     inst.state === INSTALLMENT_STATE.ACH_PENDING
	//   ) {
	//     result = true;
	//   }
	//   return result;
	// };

	// generatePayNowOrCancelButton = (text, action, inst) => {
	//   return (
	//     <StyledTableCell align="center">
	//       <Button
	//         id={text === "cancel" ? "cancel-button" : "agree-button"}
	//         onClick={() => {
	//           action(inst);
	//         }}
	//       >
	//         {this.props.t(`buttons.${text}`)}
	//       </Button>
	//     </StyledTableCell>
	//   );
	// };

	// CancelPayment = async (inst) => {
	//   try {
	//     this.startLoader();
	//     const requestBody = {
	//       action: LOAN_MODIFICATION_ACTION.CANCEL_INSTALLMENT_TRANSFER,
	//       installment_id: inst.id,
	//     };
	//     const response = await LoanService.paymentAction(
	//       this.props.loanData.id,
	//       requestBody
	//     );
	//     await this.props.refreshState();
	//     if (!response.status) {
	//       toastError(response.data);
	//     }
	//     this.stopLoader();
	//   } catch (err) {
	//     console.log(err);
	//     this.stopLoader();
	//   }
	// };

	// popupOnCancelPayment = (data) => {
	//   popUpOnCancelTranfer(
	//     this.props.t("buttons.cancel_loan_transfer"),
	//     this.CancelPayment,
	//     data
	//   );
	// };

	// componentDidMount() {
	//   this.setheadingWhenModifiedTable();
	// }

	componentDidMount() {
		this.service_charge_fee();
	}

	tableData = () => {
		if (this.props.type === 'outgoing fund') {
			return this.props.table.filter(m => m.state === 'PAID');
		} else {
			return this.props.table;
		}
	};

	render() {
		// NOSONAR
		const { t, match, currentUser, loanData } = this.props;
		this.props.table.sort((a, b) => {
			if (moment(a.installment_date).diff(moment(b.installment_date), 'days') > 0) {
				return 1;
			} else {
				if (moment(b.installment_date).diff(moment(a.installment_date), 'days') > 0) {
					return -1;
				} else {
					return 0;
				}
			}
		}); // NOSONAR

		// const tableHeaderNavColor = this.props.tableColor ? this.props.tableColor : '#76C4EE';
		let tableHeaderNavColor;

		if (currentUser?.username === loanData?.created_by) {
			if (loanData?.loan_type === 'LEND') {
				tableHeaderNavColor = '#76C4EE';
			} else {
				tableHeaderNavColor = '#FFC107';
			}
		} else {
			if (loanData?.loan_type === 'LEND') {
				tableHeaderNavColor = '#FFC107';
			} else {
				tableHeaderNavColor = '#76C4EE';
			}
		}

		return (
			<>
				<section className="amortization-container">
					<Grid alignItems="center" className="mobile_grid_container" item justify="center" sm={12} xs={12}>
						{this.props.hideHeaderFooter ? null : (
							<PageHeaderTitle
								className="amortization p-x-16"
								onClick={this.props.closeAmortizationTable}
								title="Amortization Table"
							/>
						)}
						<Accordion
							className="amortization_mobile_accordion_list_bg"
							expanded={false}
							style={{ marginTop: '3rem', backgroundColor: tableHeaderNavColor }}>
							<AccordionSummary>
								<Grid container spacing={1} columns={16}>
									<Grid xs={3} sm={3} md={3}>
										<Typography variant="h5" style={{ textAlign: 'center' }}>
											{t('label.date')}
										</Typography>
									</Grid>
									<Grid xs={3} sm={3} md={3}>
										<Typography variant="h5" style={{ textAlign: 'center' }}>
											{t('label.total_loan_payment')}
										</Typography>
									</Grid>
									<Grid xs={3} sm={3} md={3}>
										<Typography variant="h5" style={{ textAlign: 'center' }}>
											{t('label.remaining_balance')}
										</Typography>
									</Grid>
									{/* <Grid xs={3} sm={3} md={3} style={{ paddingRight: "4rem" }}> */}
									<Grid xs={3} sm={3} md={3}>
										<Typography variant="h5" style={{ textAlign: 'center' }}>
											{t('label.payment')}
										</Typography>
									</Grid>
								</Grid>
							</AccordionSummary>
						</Accordion>

						{this.tableData().map((data, index) => (
							<Accordion
								className="amortization_mobile_accordion_details amortization-accordion"
								key={index}
								style={{ margin: 0 }}>
								<AccordionSummary
									aria-controls="panel1a-content"
									classes={{
										expandIcon: 'custom-expand-icon'
									}}
									expandIcon={<ExpandIcon />}
									id="panel1a-header">
									<Grid container spacing={1} columns={16}>
										<Grid xs={3} sm={3} md={3}>
											<Typography
												className="bold-important"
												style={{ textAlign: 'center', marginLeft: '-7px', width: '100%' }}>
												{data.transfer_date
													? GetFormat(data.transfer_date)
													: GetFormat(data.installment_date)}
											</Typography>
										</Grid>
										<Grid xs={3} sm={3} md={3}>
											<Typography
												style={{
													textAlign: 'center',
													fontWeight: 'bold',
													marginLeft: '4px',
													width: '100%',
													whiteSpace: 'nowrap'
												}}>
												{' '}
												₱ {CommaSeparator(data.emi_amount)}
											</Typography>
										</Grid>
										<Grid xs={3} sm={3} md={3}>
											<Typography
												style={{
													textAlign: 'center',
													fontWeight: 'bold',
													marginLeft: '15px',
													width: '100%',
													whiteSpace: 'nowrap'
												}}>
												₱{' '}
												{data.remaining_amount <= 1
													? amountFormate(0.0)
													: CommaSeparator(data.remaining_amount)}
											</Typography>
										</Grid>
										<Grid xs={3} sm={3} md={3}>
											<Typography
												style={{ textAlign: 'center', marginLeft: '27px', width: '100%' }}>
												{isOverDue(data.installment_date) && data.state === 'DUE'
													? 'OVERDUE'
													: data.state === 'ACH_FAILED'
													? 'FAILED'
													: data.state === 'FORGIVE'
													? 'FORGIVEN'
													: t(`installment_state.${data.state}`)}
											</Typography>
										</Grid>
									</Grid>
								</AccordionSummary>

								<AccordionDetails>
									<Grid item sm={12} xs={12} className="amortization_mobile_list_grid">
										<ListItem>
											<ListItemText
												primary={t('label.principal')}
												secondary={
													<span className="bold-important">
														₱ {CommaSeparator(data.principal_part)}
													</span>
												}
											/>
										</ListItem>
										<ListItem>
											<ListItemText
												primary={t('label.interest')}
												secondary={
													<span className="bold-important">
														₱ {CommaSeparator(data.interest_part)}
													</span>
												}
											/>
										</ListItem>
										<ListItem>
											<ListItemText
												primary="LendAmi Fee"
												secondary={
													<span className="bold-important">
														₱{' '}
														{data.transaction_fee > 0
															? CommaSeparator(data.transaction_fee)
															: CommaSeparator(this.state._lendami_service)}
													</span>
												}
											/>
										</ListItem>
										{/* {match.path === '/admin/customer/review/loan/:id' &&
											this.props?.disbursalTypeACH === 'ACH' && (
												<ListItem>
													<ListItemText
														primary="LendAmi Fee"
														secondary={`₱ ${
															CommaSeparator(this.state._lendami_service) || 0
														}`}
													/>
												</ListItem>
											)} */}
										{/* {match.path === '/admin/customer/review/loan/:id' &&
											this.props?.disbursalTypeACH !== 'ACH' && (
												<ListItem>
													<ListItemText
														primary="Cash/Check"
														secondary={`₱ ${CommaSeparator(data.principal_part)}`}
													/>
												</ListItem>
											)} */}
										{/* {this.props.loanObject?.disbursal_mode === 'ACH' && (
											<ListItem>
												<ListItemText
													primary="LendAmi Fee"
													secondary={`₱ ${CommaSeparator(this.state._lendami_service) || 0}`}
												/>
											</ListItem>
										)} */}

										{/* {this.props.loanData?.disbursal_mode === 'ACH' && (
											<ListItem>
												<ListItemText
													primary="LendAmi Fee"
													secondary={`₱ ${CommaSeparator(this.state._lendami_service) || 0}`}
												/>
											</ListItem>
										)}
										{this.props.loanObject?.disbursal_mode === 'OFFLINE' && (
											<ListItem>
												<ListItemText
													primary="Cash/Check"
													secondary={`₱ ${CommaSeparator(data.principal_part)}`}
												/>
											</ListItem>
										)}
										{this.props.loanData?.disbursal_mode === 'OFFLINE' && (
											<ListItem>
												<ListItemText
													primary="Cash/Check"
													secondary={`₱ ${CommaSeparator(data.principal_part)}`}
												/>
											</ListItem>
										)} */}
									</Grid>
								</AccordionDetails>
							</Accordion>
						))}
						{this.props.hideHeaderFooter ? null : (
							<MobileFooter onClick={this.props.closeAmortizationTable} />
						)}
					</Grid>
				</section>
				{match.path === '/admin/customer/review/loan/:id' && (
					<MobileButton style={{ margin: '40px auto' }} onClick={this.props.closeAmortizationTable} />
				)}
			</>
		);
		//   </Container>
		// </section>
	}
}

export default withRouter(hot(module)(withTranslation()(withStyles(styles)(AmortizationTable))));
